import { render } from "./PaymentMethodView.vue?vue&type=template&id=4a6b0d92"
import script from "./PaymentMethodView.vue?vue&type=script&lang=js"
export * from "./PaymentMethodView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__